var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10959 0.777778C4.10959 0.348223 3.7784 0 3.36986 0C2.96132 0 2.63014 0.348223 2.63014 0.777778V1.38272H1.72603C0.772768 1.38272 0 2.19524 0 3.19753V6.30864V12.1852C0 13.1875 0.772771 14 1.72603 14H10.274C11.2272 14 12 13.1875 12 12.1852V6.30864V3.19753C12 2.19524 11.2272 1.38272 10.274 1.38272H9.36986V0.777778C9.36986 0.348223 9.03868 0 8.63014 0C8.2216 0 7.89041 0.348223 7.89041 0.777778V1.38272H4.10959V0.777778ZM10.5205 5.53086V3.19753C10.5205 3.05435 10.4102 2.93827 10.274 2.93827H9.36986V3.54321C9.36986 3.97276 9.03868 4.32099 8.63014 4.32099C8.2216 4.32099 7.89041 3.97276 7.89041 3.54321V2.93827H4.10959V3.54321C4.10959 3.97276 3.7784 4.32099 3.36986 4.32099C2.96132 4.32099 2.63014 3.97276 2.63014 3.54321V2.93827H1.72603C1.58985 2.93827 1.47945 3.05435 1.47945 3.19753V5.53086H10.5205ZM1.47945 7.08642H10.5205V12.1852C10.5205 12.3284 10.4102 12.4444 10.274 12.4444H1.72603C1.58985 12.4444 1.47945 12.3284 1.47945 12.1852V7.08642Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.5eb482f6e5ad85b8b4406568bb6e7329.svg";
export { ForwardRef as ReactComponent };